export const ANNOTATION_PREFIX = 'devportal.traton.com';
export const RBAC_ANNOTATION_PREFIX = `rbac.${ANNOTATION_PREFIX}`;
